import Path from "../Path";
import PathPlanWalkLeft from "../plan/PathPlanWalkLeft";
import PathPlanWalkRight from "../plan/PathPlanWalkRight";
import PathTemplatePattern from "./PathTemplatePattern";


// PATTERN VALUES:
// S start
// P path
// E end
// X closed
// O open
// . ignore

export default class PatternWalkSide2 extends PathTemplatePattern {
    constructor() {
        super([
            'SPE',     // start  path   end
            'XXX'      // closed closed closed
        ],
        true);  // true to flip left/right
    }

    /**
     * Returns the minimum number of path steps required by this pattern to be applied.
     * @override
     * @returns {number}
     */    
    getMinRequiredPathSteps() {
        return 2;
    }

    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlan(path, pathIndex) {
        const start = path.tiles[pathIndex];
        const end = path.tiles[pathIndex + 2];
        return new PathPlanWalkRight(start, end, 2);
    }

    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlanFlipped(path, pathIndex) {
        const start = path.tiles[pathIndex];
        const end = path.tiles[pathIndex + 2];
        return new PathPlanWalkLeft(start, end, 2);
    }

    /**
     * @override
     * @returns {string}
     */
    toString() {
        return 'PatternWalkSide2';
    }
}